<template>
  <div
    v-if="isLoaded"
    class="grid grid-cols-[auto,auto,1fr,auto] grid-rows-[auto,1fr] place-items-center w-full px-2 py-2 text-sm transition gap-y-0 gap-x-4 cursor-pointer"
    :class="
      props.notification?.read === false
        ? 'bg-blue-4 hover:bg-blue-3 hover:bg-opacity-40 '
        : 'bg-white hover:bg-gray-3'
    "
  >
    <div
      :title="
        !props.notification?.read ? 'Markera som läst' : 'Markera som oläst'
      "
      class="h-3 w-3 rounded-full row-span-full"
      :class="!props.notification?.read ? 'bg-blue-3' : 'bg-gray-2'"
      @click="() => toggleNotificationReadStatus(props.notification.id)"
    ></div>
    <div
      class="grid place-content-center h-8 w-8 rounded-full bg-blue-3 row-span-full"
      @click="props?.notification?.callback"
    >
      <i class="text-white" :class="notificationIcon()"></i>
    </div>
    <p
      class="font-semibold place-self-start"
      @click="props?.notification?.callback"
    >
      {{ props.notification?.title }}
    </p>

    <p class="text-right text-xs text-gray-500 ml-auto">
      {{
        dateDiff === 0
          ? moment.unix(props.notification?.timestamp).format("HH:mm")
          : moment
              .unix(props.notification?.timestamp)
              .format("YYYY-MM-DD HH:mm")
      }}
    </p>
    <p
      class="text-gray-500 grid-cols-2 place-self-start max-w-[40ch]"
      v-html="truncatedMessage(props.notification?.message)"
      @click="props?.notification?.callback"
    ></p>
    <button
      class="text-xs text-red-2 hover:text-red-2 justify-self-end self-start"
      @click="() => deleteNotification(props.notification)"
    >
      Ta bort
    </button>
  </div>
</template>
<script setup lang="ts">
import moment from "moment";
import { defineProps, defineEmits, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { INotificationItem } from "../models/Notifications";
const DELETE_NOTIFICATION = "deleteNotification";
const DELETE_ALL_NOTIFICATION = "deleteAllNotification";

const props = withDefaults(
  defineProps<{
    notification: INotificationItem;
    maxMessageLength?: number;
  }>(),
  {
    maxMessageLength: 71,
  }
);
const isLoaded = ref(false);
const notificationIcon = () => {
  switch (props.notification?.type) {
    case "application":
      return "fa-solid fa-user-plus";
    case "position":
      return "fa-solid fa-rocket";
    case "alert":
    case "error":
      return "fa-solid fa-circle-exclamation";
    default:
      return "fa-solid fa-star";
  }
};
onMounted(() => {
  isLoaded.value = true;
});
const truncatedMessage = (message: string) => {
  if (message?.length > props.maxMessageLength) {
    return message.substring(0, props.maxMessageLength - 3) + "...";
  }
  return message;
};
const emit = defineEmits<{
  (e: typeof DELETE_NOTIFICATION, v: INotificationItem): void;
  (e: typeof DELETE_ALL_NOTIFICATION, v: INotificationItem): void;
}>();

const store = useStore();

const toggleNotificationReadStatus = async (id: number) => {
  if (props.notification?.read) {
    await store.dispatch("markAsUnread", props.notification.id);
  } else {
    await store.dispatch("markAsRead", props.notification.id);
  }
};

const deleteNotification = async (id: INotificationItem) => {
  emit(DELETE_NOTIFICATION, id);
};

const dateDiff = moment(props.notification?.timestamp).diff(moment(), "days");
console.log(dateDiff);
</script>
